
export const slugify = (text) => {
  return text
    .normalize("NFD")                     // separa letras de sus acentos
    .replace(/[\u0300-\u036f]/g, "")      // elimina los acentos/tildes
    .replace(/\s+/g, '-')                 // reemplaza espacios por guiones
    .replace(/[^a-zA-Z0-9-]/g, '')        // elimina todo lo que no sea letras, números o guiones
    .toLowerCase();                       // convierte a minúsculas
}